import { useContext } from 'react';
import { AppContext } from '../../../../context/listingsContext';
import { CATEGORY_SPECIFIC_EXPOSURE } from '../FilterRow.constants';
import type { CategoryExposure, SubCategoryFilter } from '../FilterRow.types';
import { resolveCategoryExposure } from '../utils';
import { debugCategoryExposure } from '../utils/debugCategoryExposure';

interface UseCategoryExposureParams {
    subCategory?: SubCategoryFilter;
    isSearchFlow: boolean;
}

/** Which category controls the row shows. Only the filters modal groups on a search page can get "categories". */
export const useCategoryExposure = ({ subCategory, isSearchFlow }: UseCategoryExposureParams): CategoryExposure => {
    const { inFiltersModalTest, dominantLeafCategory, dominateSubCategoryId, appFilters } = useContext(AppContext);

    if (!inFiltersModalTest || !isSearchFlow) {
        debugCategoryExposure('gate closed -> categorySpecific', { inFiltersModalTest, isSearchFlow });

        return CATEGORY_SPECIFIC_EXPOSURE;
    }

    return resolveCategoryExposure({
        subCategory,
        dominantLeafCategory,
        dominantLeafCategoryParent: dominateSubCategoryId,
        exposedFilters: appFilters?.exposedFilters,
        visualFilters: appFilters?.visualFilters,
    });
};
